/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { OrgaoListComponent } from "./orgao-list/orgao-list.component";
import { OrgaoFormComponent } from "./orgao-form/orgao-form.component";
import { editRoute, newRoute } from "../../shared/services/data.service";
import { OrgaoTipoListComponent } from "./orgao-tipos/orgao-tipo-list/orgao-tipo-list.component";
import { OrgaoTipoFormComponent } from "./orgao-tipos/orgao-tipo-form/orgao-tipo-form.component";
import { orgaoTiposRoute } from "./orgao-tipos/shared/data.service";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class OrgaosRoutingModule {}

export const orgaosRoutes: any[] = [
  {
    path: '',
    component: OrgaoListComponent
  },{
    path: editRoute + '/:id',
    component: OrgaoFormComponent
  },{
    path: newRoute,
    component: OrgaoFormComponent
  },{
    path: orgaoTiposRoute,
    component: OrgaoTipoListComponent
  },{
    path: orgaoTiposRoute + '/' + editRoute + '/:id',
    component: OrgaoTipoFormComponent
  },{
    path: orgaoTiposRoute + '/' + newRoute,
    component: OrgaoTipoFormComponent
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/orgaos-routing.module.ts
 **/